import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Landing from './pages/Landing';
import TermsOfService from './pages/legal/TermsOfService';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import ReturnRefundPolicy from './pages/legal/ReturnRefundPolicy';
import Main from './pages/Main';
import ComingSoon from './pages/ComingSoon';
import Summary from './features/report/pages/Summary';
import MainLayout from './layout/components/MainLayout';
import TemplateReport from './features/report/pages/TemplateReport';
import DetailsReport from './features/report/pages/DetailsReport';
import NumberSearch from './features/report/pages/NumberSearch';
import Payments from './features/report/pages/Payments';
import UserFlowResponsesReport from './features/report/pages/UserFlowResponsesReport';
import SendTemplate from './features/campaign/pages/SendTemplate';
import Messages from './features/chat/pages/MessagesList';
import LiveChat from './features/chat/pages/LiveChat';
import Templates from './features/templates/pages/Templates';
import CreateTemplate from './features/templates/pages/CreateTemplate';
import SwaggerPage from './features/api/pages/SwaggerPage';
import AdminRoute from './features/admin/components/AdminRoute';
import CreateUser from './features/admin/pages/CreateUser';
import ManageUsers from './features/admin/pages/ManageUsers';
import AddBalance from './features/admin/pages/AddBalance';
import ManageCatalogue from './features/admin/pages/ManageCatalogue';
import ManagePricing from './features/admin/pages/ManagePricing';
import MessageStatsOverview from './features/admin/pages/MessageStatsOverview';
import UserOverview from './features/report/pages/UserOverview';
import ChangePassword from './features/settings/pages/ChangePassword';
import AutoReply from './features/settings/pages/AutoReply';
import AuthLogs from './features/mis/pages/AuthLogs';
import UserCatalogue from './features/catalogue/pages/UserCatalogue';
import BotBuilderList from './features/bot-builder/pages/BotBuilderList';
import BotBuilderEditor from './features/bot-builder/pages/BotBuilderEditor';

const App = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/return-refund-policy" element={<ReturnRefundPolicy />} />
      <Route path="/main" element={<MainLayout />}>
        <Route index element={<Main />} />
        <Route path="Dashboard" element={<Main />} />
        <Route path="templates" element={<Templates />} />
        <Route path="summary" element={<Summary />} />
        <Route path="overview" element={<UserOverview />} />
        <Route path="details_report" element={<DetailsReport />} />
        <Route path="number_message_report" element={<NumberSearch />} />
        <Route path="user_payments_report" element={<Payments />} />
        <Route path="user_flow_responses_report" element={<UserFlowResponsesReport />} />
        <Route path="template_report" element={<TemplateReport />} />
        <Route path="template-report" element={<TemplateReport />} />
        <Route path="send-template" element={<SendTemplate />} />
        <Route path="create-template" element={<CreateTemplate />} />
        <Route path="Messages" element={<Messages />} />
        <Route path="chat" element={<LiveChat />} />
        <Route path="chat/:waid" element={<LiveChat />} />
        <Route path="swagger" element={<SwaggerPage />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="auto-reply" element={<AutoReply />} />
        <Route path="catalogue" element={<UserCatalogue />} />
        <Route path="bot-builder" element={<BotBuilderList />} />
        <Route path="bot-builder/:id" element={<BotBuilderEditor />} />
        <Route path="mis/logs" element={<AuthLogs />} />
        <Route path="under_construction" element={<ComingSoon />} />
        <Route path="site_construction" element={<ComingSoon />} />
        <Route path="site_comming_soon" element={<ComingSoon />} />
        <Route path="site_under_construction" element={<ComingSoon />} />
        <Route
          path="admin/overview"
          element={
            <AdminRoute>
              <MessageStatsOverview />
            </AdminRoute>
          }
        />
        <Route
          path="admin/create-user"
          element={
            <AdminRoute>
              <CreateUser />
            </AdminRoute>
          }
        />
        <Route
          path="admin/manage-users"
          element={
            <AdminRoute>
              <ManageUsers />
            </AdminRoute>
          }
        />
        <Route
          path="admin/add-balance"
          element={
            <AdminRoute>
              <AddBalance />
            </AdminRoute>
          }
        />
        <Route
          path="admin/pricing"
          element={
            <AdminRoute>
              <ManagePricing />
            </AdminRoute>
          }
        />
        <Route
          path="admin/catalogue"
          element={
            <AdminRoute>
              <ManageCatalogue />
            </AdminRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

export default App;
